import XResizableTextarea from "../common/XResizableTextarea";
import { textareaFieldStyleClasses } from "../common/formInputClasses";

export const textEditorSectionClasses =
  "bg-white border-2 border-border border-l-[calc(var(--spacing)*1.5)] border-l-primary-light-2 " +
  "rounded-lg p-4 shadow-[0_1px_3px_rgba(13,43,76,0.08)]";

export const textEditorSectionAltClasses = "bg-surface-light! border-l-primary-tint!";

export const textEditorTextareaClasses = "w-full text-sm leading-[1.6]";

const DemandStudioSectionEditor = ({ label, value, onChange }) => {
  return (
    <div className={textEditorSectionClasses}>
      <div className="font-semibold mb-2">{label}</div>
      <XResizableTextarea
        name={`sectionText-${label}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="No AI output available for this section"
        className={`${textEditorTextareaClasses} ${textareaFieldStyleClasses}`}
        minHeight="6rem"
      />
    </div>
  );
};

export default DemandStudioSectionEditor;
